'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var CardEditButton = require('./CardEditButton.js');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["variant"];
/**
 * Card footer edit button
 *
 * Edit button used in the footer of the card; usually in tandem with the
 * empty component.
 */
var CardFooterEditButton = react.forwardRef(function (props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'solid' : _props$variant,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(CardEditButton.CardEditButton, _extends__default["default"]({
    variant: variant
  }, rest, {
    ref: ref
  }));
});
CardFooterEditButton.displayName = 'CardFooterEditButton';
exports.CardFooterEditButton = CardFooterEditButton;